import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { BaSeContainer, BaSeDialogContext } from '@base/react';
import { PaddingContainer } from './produtos-styled';
import { useTiposProdutosService } from '../../hooks/tipo-produtos-service';
import { GestaoArquivos } from '../../components/gestao-arquivos/gestao-arquivos';
import { EnviarArquivos } from '../../components/gestao-arquivos/enviar-arquivos';
import { useProdutos } from './hooks/useProdutos';
import { useViewNavigation, VIEW_MODES } from './hooks/useViewNavigation';
import { useProductModals } from './hooks/useProductModals';
import { PageHeader } from './components/PageHeader';
import { ProductsTable } from './components/ProductsTable';
import { ProductForm } from './components/ProductForm';

// eslint-disable-next-line
export const ProdutosPage = () => {
  const [tiposProdutos, setTiposProdutos] = React.useState([]);
  const { isAuthenticated, isInitialized } = Sebrae.useAuth();
  const { showNotification, showModal } = React.useContext(BaSeDialogContext);

  const {
    produtos,
    total,
    loading,
    error,
    fetchData,
    handleSave,
    handleUpdate,
    handleDelete,
    getImageBlob,
  } = useProdutos();

  const {
    viewMode,
    formState,
    fileManagerState,
    navigateToList,
    navigateToNewProduct,
    navigateToEditProduct,
    navigateToFileManager,
    navigateToSendFile,
    navigateBackToFileManager,
    handleBackNavigation,
    updateFormTitle,
    updateFormIsUpdate,
  } = useViewNavigation();

  const { getAtivos } = useTiposProdutosService();

  const { showDeleteModal } = useProductModals(
    handleDelete,
    showModal,
    showNotification,
  );

  React.useEffect(() => {
    if (error && isInitialized && isAuthenticated) {
      showNotification({
        message: 'Erro ao buscar produtos',
        color: 'destructive',
      });
    }
  }, [error, isInitialized, isAuthenticated, showNotification]);

  React.useEffect(() => {
    getAtivos()
      .then((list) => {
        setTiposProdutos(
          list.map((item) => ({
            id: item.id,
            label: item.nome,
            tipoCadastro: item.tipoCadastro,
          })),
        );
      })
      .catch(() => {
        showNotification({
          message: 'Erro ao buscar tipos de produtos',
          color: 'destructive',
        });
      });
  }, [getAtivos, showNotification]);

  return (
    <div>
      <PageHeader
        viewMode={viewMode}
        formTitle={formState.title}
        fileManagerSubtitle={fileManagerState.subtitle}
        onNewProduct={navigateToNewProduct}
        onSendFile={navigateToSendFile}
        onBack={handleBackNavigation}
      />
      <BaSeContainer delimitedOnBreakpoint="desktop" color="#F5F7FA">
        <PaddingContainer
          maxWidth={viewMode === VIEW_MODES.SEND_FILE ? 850 : 0}
        >
          {viewMode === VIEW_MODES.SEND_FILE && (
            <EnviarArquivos
              setIsSendFile={navigateToSendFile}
              setIsFileMenage={navigateBackToFileManager}
              codigoProduto={fileManagerState.codigoProduto}
            />
          )}
          {viewMode === VIEW_MODES.FILE_MANAGER && (
            <GestaoArquivos codigoProduto={fileManagerState.codigoProduto} />
          )}
          {viewMode === VIEW_MODES.FORM && (
            <ProductForm
              formState={formState}
              tiposProdutos={tiposProdutos}
              onSave={handleSave}
              onUpdate={handleUpdate}
              onClose={navigateToList}
              onTitleChange={updateFormTitle}
              onUpdateChange={updateFormIsUpdate}
              getImageBlob={getImageBlob}
              showNotification={showNotification}
              showModal={showModal}
            />
          )}
          {viewMode === VIEW_MODES.LIST && (
            <ProductsTable
              produtos={produtos}
              total={total}
              loading={loading}
              fetchData={fetchData}
              onEdit={navigateToEditProduct}
              onManageFiles={navigateToFileManager}
              onDelete={showDeleteModal}
            />
          )}
        </PaddingContainer>
      </BaSeContainer>
    </div>
  );
};
